import { Box, Tab, Tabs } from "@mui/material";
import CompanyAnalytics from "./CompanyAnalytics";
import I18nKey from "translations/I18nKey";
import { TabStyle, TabsStyle } from "pages/Ranger/style";
import { useState } from "react";
import { useIntl } from "react-intl";
import UserAnalytics from "./UserAnalytics";
import { analyticsWrapper, defaultTabStyle, selectedTabStyle } from "./styles";

const Analytics = () => {
  const intl = useIntl();
  const [value, setValue] = useState<number>(1);

  const handleChange = (id: number) => {
    setValue(id);
  };

  return (
    <>
      <Box sx={analyticsWrapper}>
      <h2>
        {intl.formatMessage({
          id: I18nKey.ANALYTICS,
        })}
      </h2>
        <Tabs
          value={value}
          sx={TabsStyle}
          TabIndicatorProps={{
            hidden: true,
          }}
        >
          <Tab
            label={intl.formatMessage({
              id: I18nKey.COMPANY,
            })}
            onClick={() => handleChange(1)}
            disableRipple
            key={2}
            value={2}
            sx={{
              ...TabStyle,
             ...(value === 1 ? selectedTabStyle : defaultTabStyle),
            }}
          />
          <Tab
            label={intl.formatMessage({
              id: I18nKey.SELLER,
            })}
            disableRipple
            onClick={() => handleChange(2)}
            key={3}
            value={3}
            sx={{
              ...TabStyle,
              ...(value === 2 ? selectedTabStyle : defaultTabStyle),
            }}
          />
        </Tabs>

        {value === 1 && <CompanyAnalytics />}
        {value === 2 && <UserAnalytics />}
      </Box>
    </>
  );
};

export default Analytics;
